import { render, staticRenderFns } from "./index-left.vue?vue&type=template&id=dafabd10&scoped=true"
import script from "./index-left.vue?vue&type=script&lang=js"
export * from "./index-left.vue?vue&type=script&lang=js"
import style0 from "./index-left.vue?vue&type=style&index=0&id=dafabd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafabd10",
  null
  
)

export default component.exports